import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function ServiceDepartment() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link className="active" to="/service-department">Service Department</Link>
          <Link to="/baler-refurbishing-services">Baler Refurbishing Services</Link>
          <Link to="/baler-replacement-parts">Baler Replacement Parts</Link>
          <Link to="/baling-wire">Baling Wire</Link>
          <Link to="/contact/baling-wire">Baling Wire Quotation</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Parts &amp; Service</span>
          <h2>Service Department</h2>
          <div className="content-stack">
            <section className="content-block">
              <div className="selection-media-row">
                <div className="selection-media-copy">
                  <div className="body-copy">Factory field service for C+M products can be scheduled by contacting our service department or by email at <a href="mailto:service@baling.com">service@baling.com</a>.</div>
                  <div className="body-copy">Qualified C+M dealers can provide high-quality <strong>repair services</strong> with active online C+M support. In certain areas, C+M <strong>factory technicians</strong> or C+M dealer technicians can service most any brand of baler or waste compactor.</div>
                  <div className="body-copy">If C+M cannot handle your service request, we will forward it to one of our <strong>qualified dealers</strong> or trade associates.</div>
                </div>
                <img className="service-side-image" src="/img/thumbnails/ServiceDepartmentPic1.jpg" alt="C+M service department vehicle" />
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/general-inquiry">Contact C+M <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default ServiceDepartment;
